import * as Yup from 'yup';
import { chargeValidationSchema } from './LineItemValidation';

const ChargeItemValidationSchema = Yup.object().shape({
  charges: Yup.array().of(chargeValidationSchema),
});

export { ChargeItemValidationSchema };
